import Button from "@edaz/edazkit/Button/index";
import { IconType } from "@edaz/edazkit/Icon";
import type { ColumnDefinition } from "@frui.ts/dataviews";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import type InternalReportResponse from "entities/internalReportResponse";
import ReportRequestStatus from "entities/reportRequestStatus";
import { observer } from "mobx-react-lite";
import React from "react";
import { busyIdentificator } from "utils/busyWatcher";
import { formatDateMonth, formatDateTime, translateEnum } from "utils/localizations";
import ExpenseReportsListViewModel from "viewModels/timeCharges/reporting/internalReports/expenseReports/expenseReportsListViewModel";
import ListView from "views/common/list";

const ExpenseReportsListView: ViewComponent<ExpenseReportsListViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<InternalReportResponse>[] = [
    {
      title: vm.translateAttribute("fileName"),
      property: "fileName",
      cellProps: _ => ({ style: { width: 400 } }),
    },
    {
      title: vm.translateAttribute("_fromDate"),
      valueFormatter: props => formatDateMonth(props.value),
      property: "fromDate",
    },
    {
      title: vm.translateAttribute("_toDate"),
      valueFormatter: props => formatDateMonth(props.value),
      property: "toDate",
    },
    {
      title: vm.translateAttribute("processedAt"),
      valueFormatter: props => formatDateTime(props.value),
      property: "processedAt",
    },
    {
      title: vm.translateAttribute("createdBy"),
      property: "createdBy",
      cellProps: _ => ({ style: { width: 150 } }),
    },
    {
      title: vm.translateAttribute("status"),
      property: "status",
      valueFormatter: props => translateEnum("reportRequestStatus", props.value),
      cellProps: _ => ({ style: { width: 200 } }),
    },
  ];

  const actionButtons = (item: InternalReportResponse) => {
    const isBusy = vm.busyWatcher.checkBusy(busyIdentificator([item]));

    return (
      <>
        {item.status === ReportRequestStatus.Processed && (
          <Button
            variant="success"
            size="sm"
            className="rounded"
            onClick={() => vm.onDownload(item)}
            disabled={isBusy}
            iconLeft={isBusy ? IconType.Spinner : IconType.Download}>
            {vm.translate("downloadFile")}
          </Button>
        )}
      </>
    );
  };

  return (
    <>
      <ListView vm={vm} columns={columns} showDetailWithList={true} hideTitle={true} actionButtons={actionButtons} />
    </>
  );
});

registerView(ExpenseReportsListView, ExpenseReportsListViewModel);
